module.exports = function() { return {}; };
